import React from 'react';
import { LinearProgress, makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

const SingleSubjectItem = ({ subject }) => {
    const navigate = useNavigate();
    let progressValue = Math.ceil(subject.attemptedQuesCount / subject.questionCount * 100);
    const classes = useStyles();
    return (
        <li onClick={() => navigate('/my-app/practice/subject/' + subject._id)}>
            <div className={classes.imageContainer}>
                <img
                    src={subject.image && subject.image.imageUrl ? subject.image.imageUrl : '/categories/thumbnail/Reasoning.webp'}
                    alt=""/>
            </div>
            <div className={classes.testName}>
                <h4>{subject.name}</h4>
                <div>
                    <LinearProgress variant="determinate" value={progressValue}/>
                    <span><i className="fa fa-chevron-right" aria-hidden="true"/></span>
                </div>
                <p>{progressValue}%</p>
            </div>
        </li>
    );
};

const useStyles = makeStyles(theme => ({
    imageContainer: {
        width: 60,
        minWidth: 60,
        height: 60,
        marginRight: 20,
        marginBottom: 15,
        '& img': {
            width: '100%',
            height: '100%'
        }
    },
    testName: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderBottom: '1px solid #e1e2e1',
        paddingBottom: 15,
        '& > div': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& > div': {
                margin: '10px 0',
                height: 6,
                borderRadius: 20,
                backgroundColor: '#e1e2e1',
                width: '85%',
                '& .MuiLinearProgress-barColorPrimary': {
                    backgroundColor: '#00BFA5'
                },
            },
            '& span': {
                color: '#e1e2e1'
            }
        },
        '& h4': {
            margin: 0,
            color: '#000',
            fontSize: 14,
            fontWeight: 'bold'
        },
        '& p': {
            color: '#00BFA5',
            margin: 0,
            fontSize: 12,
            fontWeight: 'bold'
        }
    }
}));

export default SingleSubjectItem;
